/**
 *
 */
export enum ITNodeLabel {
    IT = "IT Load",
}